import { cx } from "../../lib/cx.js";
import { Button } from "../Button/Button.js";
import { Alert } from "../Alert/Alert.js";
/* empty css                        */
import { jsx } from "react/jsx-runtime";
//#region src/components/ImpersonationBanner/ImpersonationBanner.tsx
/**
* The warning shown on every page while an admin views the console as a user. It
* persists until they exit: there's no dismiss. Put it in AppShell's `banner`.
*/
function ImpersonationBanner({ userName, onExit, exitLabel = "Back to user list", title = `Viewing as ${userName}`, children = `You’re seeing what ${userName} sees.`, className, ...rest }) {
	return /* @__PURE__ */ jsx(Alert, {
		...rest,
		role: "status",
		tone: "warning",
		title,
		className: cx("ds-impersonation-banner", className),
		action: /* @__PURE__ */ jsx(Button, {
			variant: "secondary",
			size: "sm",
			onClick: onExit,
			children: exitLabel
		}),
		children
	});
}
//#endregion
export { ImpersonationBanner };

//# sourceMappingURL=ImpersonationBanner.js.map